//@flow
import uuid from 'uuid/v4';

export type MsgType<StatusEnumType> = {
    data: {
        id: string,
        status: StatusEnumType,
        err?: any, // TODO defFine error type
        message: string,
        payload?: Object
    }
};

type PromisesType = {
    [string]: Array<({}) => void>
};

/**
 * Promise based controller for workers
 * Accepts payload and worker and creates promise and save it
 * Once worker sends payload back with id resolve that promise and removes from memory
 *
 * @class WorkerController
 */
class WorkerController<SendMsgPayloadType, MsgStatusEnumType> {
    promises: PromisesType = {};

    sendMsg(payload: SendMsgPayloadType, worker: Worker): ?Promise<*> {
        if (worker) {
            const msgId = uuid();
            const msg = {
                id: msgId,
                payload
            };
            return new Promise((...promise) => {
                this.promises[msgId] = promise;
                worker.postMessage(msg);
            });
        }
    }

    handleMsg = (msg: MsgType<MsgStatusEnumType>): void => {
        const { id, err, payload } = msg.data;
        if (id) {
            // ignoring other postmessage calls by other workers used
            const [resolve, reject] = this.promises[id];
            if (payload) {
                if (resolve) {
                    resolve(payload);
                }
            } else {
                // error condition
                if (reject) {
                    if (err) {
                        reject(err);
                    } else {
                        reject(new Error('Got nothing in error object'));
                    }
                }
            }

            // purge used callbacks
            delete this.promises[id];
        }
    };
}

export default WorkerController;
